import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-text-sm" }

import { computed, PropType, ref } from "vue";
  import { QSelect, ValidationRule } from "quasar";
  import { ResidentialStatusOptions } from "src/const/select-options";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResidentialStatusSelect',
  props: {
    modelValue: {
      type: Number,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array as PropType<ValidationRule[]>,
      default: () => []
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props;

  const value = computed({
    get() {
      return props.modelValue;
    },
    set(value) {
      emit('update:modelValue', value);
    }
  });

  const emit = __emit;

  const residentialStatusRef = ref<QSelect | null>(null);

  function validate() {
    return residentialStatusRef.value?.validate();
  }

  __expose({ validate });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(QSelect), {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    modelModifiers: { number: true },
    options: _unref(ResidentialStatusOptions),
    ref_key: "residentialStatusRef",
    ref: residentialStatusRef,
    rules: __props.rules,
    "emit-value": "",
    "label-color": "tw-text-slate-500",
    class: _normalizeClass(["tw-text-slate-500", residentialStatusRef.value?.hasError ? '' : 'tw-shadow-sm']),
    "input-class": "tw-text-slate-500",
    "popup-content-class": "tw-text-sm tw-text-slate-500 limit-dd-height",
    "dropdown-icon": "mdi-chevron-down",
    label: value.value ? undefined : 'Select a status...',
    "map-options": "",
    "data-cy": "residentialStatusSelect",
    outlined: "",
    dense: "",
    "data-clarity-unmask": "true"
  }, {
    selected: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(ResidentialStatusOptions).find(t => t.value === value.value)?.label), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "rules", "class", "label"]))
}
}

})